/**
 * 学习乐园 · 排排序题材包：长度单位（paixu/pack-changdu.js）
 * ---------------------------------------------------------------------------
 * 毫米厘米分米米千米从小到大排（只收小学口径的五个常用长度单位）。
 * note 给每个单位一个「身上的参照物」——硬币、指甲盖、一拃、双臂、操场，
 * 排完顺序也就把量感带出来了。教学点摊明：毫米到米相邻进率是 10，
 * 唯独米到千米是 1000，最容易记错的就是这一级，winText 里点破。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.changdu = {
    id: 'changdu',
    name: '长度单位',
    hint: '从小到大排长度单位',
    cols: 5,
    winText: '毫米→厘米→分米→米，相邻进率都是 10；唯独米到千米是 1000——最容易记错的就是这一级。',
    items: [
      { face: '毫米', note: '硬币的厚度大约 1 毫米' },
      { face: '厘米', note: '指甲盖的宽度大约 1 厘米' },
      { face: '分米', note: '手掌一拃差不多，就是 10 厘米' },
      { face: '米', note: '张开双臂的长度差不多，1 米 = 10 分米' },
      { face: '千米', note: '又叫公里，标准操场两圈半是 1 千米' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
